<!-- .block-posts -->
<div class="block block-collections" *ngIf="show">
    <div class="container">
        <div class="collections-grid collections-grid-{{collections.length}}">
            <ng-container *ngFor="let collection of collections">
                <app-collection-card [collection]="collection"></app-collection-card>
            </ng-container>
        </div>
    </div>
</div>
<!-- .block-posts / end -->
